import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

moment.locale('es-mx');

moment.updateLocale('es-mx', {
  monthsShort: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
});
@Pipe({
  name: 'folioValue',
  standalone: true,
})
export class FolioValuePipe implements PipeTransform {
  transform(value: any): any {
    const dateValue = this.getDateValue(value);
    return dateValue;
  }

  getDateValue(value: any) {
    if (value) {
      let changedDate;
      let time;
      const date = moment(value.substr(8, 2), 'YY');
      const year = parseInt(date.format('YYYY'));
      // Parsing the date from the folio. for the second variable used -1 since Month values starts from 0
      const folioDate = new Date(
        year,
        value.substr(6, 2) - 1,
        value.substr(4, 2),
      );
      changedDate = moment(folioDate).format('DD MMM yyyy');
      time = value.substr(10, 2) + ':' + value.substr(12, 2);
      return changedDate + ' ' + time;
    } else {
      return null;
    }
  }
}
